import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import { ctxTachograph } from '@/contexts/TachographCtx';
import { useContext } from 'react';

export function TachoGraphDateSelectMobile({ setSelectedDates }: { setSelectedDates: (from: Date, to: Date) => void }) {
  const tachographCtx = useContext(ctxTachograph);
  if (!tachographCtx) return;

  return (
    <>
      <StaticDateRangeSelect setSelectedDates={setSelectedDates} />
    </>
  );
}
